export default __webpack_public_path__ + "static/media/agb_020.5f483d1e.jpg";